import { render } from "./hours.vue?vue&type=template&id=40a61ec7&scoped=true"
import script from "./hours.vue?vue&type=script&lang=js"
export * from "./hours.vue?vue&type=script&lang=js"

import "./hours.vue?vue&type=style&index=0&id=40a61ec7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a61ec7"]])

export default __exports__